import './Ticker.css'

const items = [
  'Diseños únicos',
  'Envíos en toda la laguna',
  '100% personalizados',
  'Pedidos por WhatsApp',
  'Catálogo actualizado diario',
]

export default function Ticker() {
  const doubled = [...items, ...items]
  return (
    <div className="ticker-wrap" aria-hidden="true">
      <div className="ticker-track">
        {doubled.map((item, i) => (
          <span key={i} className="ticker-item">
            <span className="dot">✦</span> {item}<span className="dot">✦</span>
          </span>
        ))}
      </div>
    </div>
  )
}
